import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const useStep3 = () => {
  const navigate = useNavigate();
  const { formulario, setPartialForm, salvarRascunho, enviarAprovacao } = useFormularioSecretariaMunicipalAgriculturaStore();

  const stepAtual = formulario?.step_atual ?? 1;
  const totalSteps = 7;

  const validarCamposObrigatorios = useCallback(() => {
    // servidores_cedidos_empaer e emissor_caf são obrigatórios (marcados com *)
    // Valida se os campos foram preenchidos (true = Sim, false = Não)
    const temValorEmpaer = formulario?.servidores_cedidos_empaer === true || formulario?.servidores_cedidos_empaer === false;
    const temValorCaf = formulario?.emissor_caf === true || formulario?.emissor_caf === false;
    return temValorEmpaer && temValorCaf;
  }, [formulario]);

  const checkRadio = (e: React.ChangeEvent<HTMLInputElement>, campo: any) => {
    setPartialForm(campo, e.target.value === 'true');
  };

  const handleNomeServidorChange = (index: number, value: string) => {
    if (!formulario?.nome_servidores_cedidos_empaer) {
      setPartialForm('nome_servidores_cedidos_empaer', [value]);
      return;
    }
    const newNomesServidores = [...(formulario?.nome_servidores_cedidos_empaer || [])];
    newNomesServidores[index] = value;
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  const removerCampoServidor = (index: number) => {
    const newNomesServidores = [...(formulario?.nome_servidores_cedidos_empaer || [])];
    newNomesServidores.splice(index, 1);
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  const adicionarCampoServidor = () => {
    if (!formulario?.nome_servidores_cedidos_empaer) {
      setPartialForm('nome_servidores_cedidos_empaer', ['']);
      return;
    }
    const newNomesServidores = [...(formulario?.nome_servidores_cedidos_empaer || [])];
    newNomesServidores.push('');
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  const handleAvancar = async () => {
    if (!validarCamposObrigatorios()) return;

    // Se for o último step (7), enviar para aprovação e navegar
    if (stepAtual === 7) {
      const sucesso = await enviarAprovacao();
      if (sucesso) {
        navigate(ROUTES.PACOTE_FORMULARIOS);
      }
    } else {
      // Caso contrário, avançar para o próximo step
      setPartialForm('step_atual', stepAtual + 1);
      await salvarRascunho();
    }
  };

  const handleVoltar = async () => {
    setPartialForm('step_atual', Math.max(1, stepAtual - 1));
    await salvarRascunho();
  };

  return {
    formulario,
    validarCamposObrigatorios,
    checkRadio,
    handleNomeServidorChange,
    removerCampoServidor,
    adicionarCampoServidor,
    handleAvancar,
    handleVoltar,
    setPartialForm,
    formularioInativo: formulario?.servidores_cedidos_empaer === undefined || null,
    stepAtual,
    totalSteps,
  };
};
